(function () {
  'use strict';
  const scriptUrl = document.currentScript.src;
  const desktop = matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const cards = [];

  function labelToggle(card) {
    card.toggle.setAttribute('aria-label', (card.manuallyPaused ? 'Play ' : 'Pause ') + card.key + ' animation');
    card.toggle.innerHTML = card.manuallyPaused ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7 4 9 6-9 6Z"/></svg>' : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7 5v10M13 5v10"/></svg>';
  }

  // 2026-10-01: category tile videos turned off. The tile photos were replaced and the old videos no longer match.
  // Set to true to turn the hover / mobile autoplay videos back on.
  const VIDEOS_ENABLED = false;

  function wantsPlayback(card) {
    return VIDEOS_ENABLED && !document.hidden && !reducedMotion.matches && card.visible &&
      !document.querySelector('dialog[open]') &&
      (desktop.matches ? card.hovered : !card.manuallyPaused);
  }

  function stop(card) {
    card.generation++;
    clearTimeout(card.timer);
    card.timer = null;
    card.active = false;
    card.video.pause();
    card.media.classList.remove('is-playing');
    card.toggle.hidden = desktop.matches || !card.visible || !card.manuallyPaused || reducedMotion.matches;
    if (card.video.hasAttribute('src')) {
      card.video.removeAttribute('src');
      card.video.load();
    }
  }

  function play(card) {
    card.timer = null;
    if (!wantsPlayback(card)) return;
    const generation = ++card.generation;
    card.active = true;
    if (!card.video.hasAttribute('src')) card.video.src = card.url;
    card.video.play().then(function () {
      if (generation !== card.generation) return;
      if (!card.active || !wantsPlayback(card)) {
        if (!card.active) card.video.pause();
        else stop(card);
        return;
      }
      card.media.classList.add('is-playing');
      card.toggle.hidden = desktop.matches;
    }).catch(function (error) {
      if (generation !== card.generation || !card.active) return;
      if (error.name === 'NotAllowedError' && !desktop.matches) {
        card.manuallyPaused = true;
        labelToggle(card);
      }
      stop(card);
    });
  }

  function sync(card) {
    if (!wantsPlayback(card)) return stop(card);
    if (!card.active && !card.timer) card.timer = setTimeout(function () { play(card); }, desktop.matches ? 120 : 180);
  }

  function init() {
    const grid = document.querySelector('#collections .store-category-grid');
    if (!grid || grid.dataset.motionReady) return;
    grid.dataset.motionReady = 'true';
    grid.querySelectorAll(':scope > a').forEach(function (link) {
      const image = link.querySelector('img');
      const key = image && (image.getAttribute('src') || '').match(/ds-category-(rings|earrings|necklaces|bracelets)-poster/);
      if (!key) return;
      const media = image.parentElement;
      const video = document.createElement('video');
      video.className = 'ds-category-video';
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'none';
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('tabindex', '-1');
      const wrapper = document.createElement('div');
      wrapper.className = 'ds-category-card';
      link.before(wrapper);
      wrapper.append(link);
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'ds-category-pause';
      toggle.hidden = true;
      toggle.setAttribute('aria-label', 'Pause ' + key[1] + ' animation');
      toggle.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7 5v10M13 5v10"/></svg>';
      wrapper.append(toggle);
      media.classList.add('ds-category-media');
      media.append(video);
      const card = {link, media, video, toggle, key: key[1], generation: 0, visible: false, hovered: false, active: false, manuallyPaused: false, timer: null, url: new URL('ds-preview-category-' + key[1] + '.mp4', scriptUrl).href};
      cards.push(card);
      link.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'touch') { card.hovered = true; sync(card); }
      });
      link.addEventListener('pointerleave', function () { card.hovered = false; sync(card); });
      toggle.addEventListener('click', function () {
        card.manuallyPaused = !card.manuallyPaused;
        labelToggle(card);
        if (card.manuallyPaused) stop(card);
        else play(card);
      });
      video.addEventListener('error', function () { stop(card); });
    });

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        const card = cards.find(function (item) { return item.media === entry.target; });
        card.visible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
        sync(card);
      });
    }, {threshold: [0, 0.35], rootMargin: '0px'});
    cards.forEach(function (card) { observer.observe(card.media); });
    [desktop, reducedMotion].forEach(function (query) { query.addEventListener('change', function () { cards.forEach(sync); }); });
    document.addEventListener('visibilitychange', function () { cards.forEach(sync); });
    window.addEventListener('pagehide', function () { cards.forEach(stop); });
    window.addEventListener('pageshow', function () { cards.forEach(sync); });
    new MutationObserver(function () { cards.forEach(sync); }).observe(document.body, {subtree: true, attributes: true, attributeFilter: ['open']});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
